<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
            </button>

            <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
            </button>
          </div>
          <div class="d-flex">
            <p class="text-muted mb-0 hover-cursor link">&nbsp;Warehouse</p>
            <p class="text-muted mb-0 hover-cursor link">&nbsp;/&nbsp;Inventory Sparepart</p>
            <p class="text-primary mb-0 hover-cursor">&nbsp;/&nbsp;{{ sku }}</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ admin }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                  <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid mt-3">
          <div class="row mt-">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <!-- <div class="search-table container-fluid"> -->
                  <div class="d-flex mb-2 flex-wrap">
                    <!-- <div class="col-lg-2 col-sm mobile-div"> -->
                    <div class="mr-2">
                      <button class="btn btn-primary mt-4" @click="openModal('Add')"> Add In</button>
                    </div>
                    <div class="mr-2" style="width: 161px;">
                        Status
                        <multiselect v-model="searchStatus" :options="statusOption" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Status"></multiselect>
                    </div>
                    <div style="width: 220px" class="mr-2">
                        Warehouse
                        <multiselect v-model="searchWarehouse" :options="warehouseOption" label="warehouseName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Warehouse" track-by="warehouseName"></multiselect>
                    </div>
                    <div>
                    <!-- <div class="col-lg-2 col-sm mobile-div"> -->
                        <button class="btn btn-primary mt-4 mr-2" @click="searchData(1)"> Search </button>
                        <button class="btn btn-primary mt-4" @click="resetSearch"> Reset </button>
                    </div>
                  </div>
                <!-- </div> -->
                
                <div class="card mt-4" style="margin-bottom: -1px">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-3">
                        <table>
                          <tr>
                            <td style="width: 75px;" valign="top">SKU</td>
                            <td style="width: 10px;" valign="top">:</td>
                            <td>{{ sku }}</td>
                          </tr>
                          <tr v-if="detailSparepart.length != 0">
                            <td valign="top">Total Qty</td>
                            <td valign="top">:</td>
                            <td>{{ detailSparepart[0].total }} units</td>
                          </tr>
                        </table>
                      </div>
                      <div class="col-3" v-if="detailSparepart.length != 0">
                        <table>
                          <tr>
                            <td style="width: 105px;" valign="top">Type</td>
                            <td style="width: 10px;" valign="top">:</td>
                            <td>{{ detailSparepart[0].type }}</td>
                          </tr>
                          <tr>
                            <td valign="top">Available Qty</td>
                            <td valign="top">:</td>
                            <td>{{ detailSparepart[0].available }} units</td>
                          </tr>
                        </table>
                      </div>
                      <div class="col-6" v-if="detailSparepart.length != 0">
                        <table>
                          <tr>
                            <td valign="top" style="width: 75px;">Name</td>
                            <td valign="top" style="width: 10px">:</td>
                            <td>{{ detailSparepart[0].componentName }}</td>
                          </tr>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                  <thead class="">
                    <tr>
                      <th>Status</th>
                      <th>Warehouse</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loadingTable === false && totalData == '0'">
                      <td colspan="11" class="text-center">Data Not Available</td>
                    </tr>
                    <tr v-else-if="loadingTable === true">
                      <td colspan="11" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                    </tr>
                    <tr v-for="(data,index) in dataInvSparepart" :key="`invSparepart-${index}`" v-else>
                      <td>{{ data.status }}</td>
                      <td>{{ data.warehouseName }}</td>
                      <td class="text-center">
                        <button class="btn btn-primary btn-sm" @click="openModalEdit(data)"> Edit </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-between mt-3">
                  <div class="d-flex align-items-center">
                    <div style="margin-right: 10px;">
                      <select class="form-control form-control-sm" v-model="itemPerPage" @change="searchData(1)">
                              <option value="10">10</option>
                              <option value="40">40</option>
                              <option value="80">80</option>
                      </select>
                    </div>
                    <div class="total-data">
                      Total Data {{ totalData }} 
                    </div>
                  </div>
                  <div>
                    <button class="btn-sm btn-default" @click="openModal('Log')">Show Log</button>
                  </div>
                  <div>
                    <div class="pagination p8 alignRight">
                      <ul>
                        <a class="is-active link" @click="searchData(parseInt(currentPage)-1)" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                        <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                        <a class="is-active link" @click="searchData(parseInt(currentPage)+1)" v-if="currentPage != totalPage"><li>></li></a>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
      <div class="modal fade" id="modalLog" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-xl">
              <!-- Modal content-->
              <div class="modal-content">
                  <div class="modal-header">
                    <div class="d-flex justify-content-between w-100">
                      <div class="change-title">
                          <h4 class="modal-title">Inventory Sparepart Log</h4>
                      </div>
                    </div>
                      <!-- <button type="button" class="close" data-dismiss="modal">&times;</button> -->
                  </div>
                  <div class="modal-body">
                    <table class="fixed_header table-bordered table-striped">
                        <tbody class="full-width">
                            <tr>
                                <th style="min-width: 150px;">When</th>
                                <th style="min-width: 500px;">What</th>
                                <th>Who</th>
                            </tr>
                            <tr v-if="dataLog.length == 0">
                                <td colspan="3">Tidak ada Log</td>
                            </tr>
                            <tr v-else v-for="(data, index) in dataLog" :key="`log-${index}`">
                                <td valign="top">{{ data.time }}</td>
                                <td valign="top" v-html="data.text"></td>
                                <td valign="top">{{ data.ids }}</td>
                            </tr>
                        </tbody>
                    </table>
                  </div>
                  <div class="modal-footer d-flex justify-content-end">
                    <button class="btn btn-sm btn-primary" data-dismiss="modal">Ok</button>
                  </div>
              </div>
          </div>
      </div>
      <div class="modal fade" id="modalAdd" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Add In</h4>
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <div class="d-flex align-items-center">
                <span class="label-text-field">Source</span>
                <multiselect v-model="sourceAddIn" :options="sourceOption" :allow-empty="false" :select-label="'Source'" :deselect-label="''" placeholder="Source" @select="resetAddIn"></multiselect>
              </div>
              <div class="d-flex mt-2 align-items-center">
                <span class="label-text-field-two">Unique ID</span>
                <input type="text" class="form-control text-field" name="uniqueId" v-model="uniqueIdAddIn" placeholder="SKU">
                <button class="btn btn-primary ml-2" @click="getDataAddIn" :disabled="loadingGetAddIn"><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="loadingGetAddIn"><span v-if="!loadingGetAddIn">Get</span></button>
              </div>
              <div class="text-notif text-center" v-if="notFound">
                <hr>
                <span>Data Not Found</span>
              </div>
              <hr v-if="getAddIn">
              <table class="add-in" v-if="getAddIn">
                <tr>
                  <td style="width: 115px;">Source</td>
                  <td style="width: 10px;">:</td>
                  <td>{{ dataGetAddIn[0].source }} {{ dataGetAddIn[0].hash }}</td>
                </tr>
                <tr>
                  <td>SKU</td>
                  <td>:</td>
                  <td>{{ dataGetAddIn[0].sku }}</td>
                </tr>
                <tr>
                  <td>Name</td>
                  <td>:</td>
                  <td> {{ dataGetAddIn[0].componentName }}</td>
                </tr>
                <tr>
                  <td>Qty</td>
                  <td>:</td>
                  <td>
                    <input type="number" name="qty" class="form-control w-50" v-model="qtyAddIn" min="0">
                  </td>
                </tr>
                <!-- Procure -->
                <tr v-if="sourceAddIn === 'Procure'">
                  <td>Procure PIC</td>
                  <td>:</td>
                  <td>{{ dataGetAddIn[0].procurePic }}</td>
                </tr>
                <tr v-if="sourceAddIn === 'Procure'">
                  <td>Courier PIC</td>
                  <td>:</td>
                  <td>{{ dataGetAddIn[0].courierPic }}</td>
                </tr>
                <!-- Procure -->
                <!-- stock opname -->
                <tr v-if="sourceAddIn === 'Stock Opname'">
                  <td>Condition</td>
                  <td>:</td>
                  <td>
                    <multiselect v-model="conditionAddIn" :options="conditionOption" label="conditionName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Condition" track-by="conditionName"></multiselect>
                  </td>
                </tr>
                <!-- stock opname -->
                <!-- My BAG -->
                <tr v-if="sourceAddIn === 'My Bag'">
                  <td>Support PIC</td>
                  <td>:</td>
                  <td>{{ dataGetAddIn[0].pic }}</td>
                </tr>
                <!-- My Bag -->
                <tr v-if="sourceAddIn === 'Stock Opname'">
                  <td>Warehouse</td>
                  <td>:</td>
                  <td class="w-75">
                    <multiselect v-model="warehouseAddIn" :options="warehouseOptionAddIn" label="warehouseName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Select Warehouse" track-by="warehouseName"></multiselect>
                  </td>
                </tr>
              </table>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success btn-sm" :disabled="loadingDoneAddIn || loadingMore" @click="validateAddIn('more')">
                <img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="loadingMore">More Add In
              </button>
              <button type="button" class="btn btn-primary btn-sm" @click="validateAddIn('done')" :disabled="loadingDoneAddIn || loadingMore">
                <img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="loadingDoneAddIn">Done
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modalEdit" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <div class="change-title">
                <h4 class="modal-title">Edit Sparepart</h4>
              </div>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
              <div class="d-flex mt-2 align-items-center">
                <span class="label-text-field">SKU</span>
                <input type="text" class="form-control" name="sku" v-model="skuEdit" disabled>
              </div>
              <div class="d-flex align-items-center mt-2">
                <span class="label-text-field">Status</span>
                <multiselect v-model="statusEdit" :options="statusOptionEdit" :allow-empty="false" :select-label="'Status'" :deselect-label="''" placeholder="Status"></multiselect>
              </div>
              <div class="d-flex align-items-center mt-2">
                <span class="label-text-field">Warehouse</span>
                <multiselect v-model="warehouseEdit" :options="warehouseOptionEdit" label="warehouseName" :allow-empty="false" :select-label="'Warehouse'" :deselect-label="''" placeholder="Warehouse" track-by="warehouseName"></multiselect>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-primary btn-sm" @click="submitEdit" :disabled="loadingButtonSave"><img src="~@/assets/images/2.gif" style="height: 18px;margin-right: 1px;" v-if="loadingButtonSave">Save</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="modalLog" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-xl">
              <!-- Modal content-->
              <div class="modal-content">
                  <div class="modal-header">
                      <div class="change-title">
                          <h4 class="modal-title">Catalog Sparepart Log</h4>
                      </div>
                      <button type="button" class="close" data-dismiss="modal">&times;</button>
                  </div>
                  <div class="modal-body">
                      <table class="table table-sm table-bordered table-striped table-responsive-sm">
                        <thead class="">
                          <tr>
                            <th>Date</th>
                            <th>Action</th>
                            <th>Executor</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-if="loadingTable === false && totalData == '0'">
                            <td colspan="7" class="text-center">Data Not Available</td>
                          </tr>
                          <tr v-else-if="loadingTable === true">
                            <td colspan="7" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                          </tr>
                          <tr v-for="(data,index) in dataLog" :key="`dataLog-${index}`" v-else>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>
                  </div>
              </div>
          </div>
      </div>
      <!-- endModal -->
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import SideBar from '../SideBar'
export default {
  name: 'ProductPage',
  components:{
    SideBar,
    Multiselect
  },
  data () {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      admin:"",
      adminId:"",
      permission:[],
      viewInvSparepart: false,
      loadingButtonSave: false,
      loadingDoneAddIn: false,
      loadingMore: false,
      loadingGetAddIn: false,
      dataInvSparepart: [],
      totalPage:0,
      totalData:0,
      currentPage:1,
      companyName:"",
      statusOrder:"",
      loadingTable:true,
      sparepartNameAdd:'',
      itemPerPage:10,
      logSelect:'out',
      searchStatus:'All',
      statusOption:['All', 'Available', 'Broken', 'Sold', 'Reserved for complain', 'Complain', 'Reserved for order', 'Used for order', 'Assembled', 'Procurement'],
      searchWarehouse:{
        warehouseId : 0,
        warehouseName : 'All'
      },
      warehouseEdit:[],
      warehouseOption:[],
      warehouseOptionAddIn:[],
      warehouseOptionEdit:[],
      sku:'',
      detailSparepart:[],
      skuEdit:'',
      statusEdit:'',
      statusOptionEdit:['Available', 'Broken', 'Sold', 'Reserved for complain', 'Complain', 'Reserved for order', 'Used for order', 'Assembled', 'Procurement'],
      statusBefore:'',
      warehouseBefore:'',
      sourceAddIn:'Procure',
      sourceOption:['Procure','Stock Opname','My Bag'],
      uniqueIdAddIn:'',
      getAddIn:false,
      dataGetAddIn:[],
      qtyAddIn:0,
      notFound:false,
      conditionAddIn:{
        condition:0,
        conditionName:'Available'
      },
      conditionOption:[
      {
        condition:0,
        conditionName:'Available'
      },
      {
        condition:1,
        conditionName:'Broken'
      }
      ],
      warehouseAddIn:[],
      dataLog:[],
      allComponentWarehouseId:[],
      componentWarehouseIdEdit:''
    }
  },
  methods: {
    getWarehouseId(data){
        this.allComponentWarehouseId = []
        for (var i = 0; i < data.length; i++) {
          if (!this.allComponentWarehouseId.includes(data[i].componentWarehouseId)) {
              this.allComponentWarehouseId.push(data[i].componentWarehouseId)
          }
        }
        this.connectLogSparepart()
    },
    connectLogSparepart: function () {
      this.dataLog = []
      for (var i = 0; i < this.allComponentWarehouseId.length; i++) {
        this.$http
            .get(process.env.LOG_URL + "/inv_sparepart/" + this.allComponentWarehouseId[i], {
                headers: { "Asani-Token": localStorage.getItem("jwt") },
            })
            .then((response) => {
                if (response.data.status === 200) {
                  var data = response.data.content
                  for (var i = 0; i < data.length; i++) {
                    this.dataLog.push(data[i])
                  }
                  this.dataLog= this.dataLog.sort((b,a) => (a.time > b.time) ? 1 : ((b.time > a.time) ? -1 : 0))
                }
            })
            .catch(error => {
                console.log(error);
            }); 
      }
    },
    getDataAddIn(){
      this.loadingGetAddIn = true
      var self = this
      this.$http.post(process.env.GET_INFO_ITEM,{
          type:this.sourceAddIn,
          uniqueId: this.uniqueIdAddIn,
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })

            }else{
              this.loadingGetAddIn = false
              this.dataGetAddIn = response.data.content
              if (this.dataGetAddIn.length != 0) {
                this.getAddIn = true
                this.qtyAddIn = this.dataGetAddIn[0].qty
                this.notFound = false
              }else{
                this.notFound = true
              }
            }
      })
      .catch(error => {
        self.loadingGetAddIn = false
        alert('Error with API')
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    resetAddIn(){
      this.dataGetAddIn = []
      this.getAddIn = false
      this.qtyAddIn = 0
      this.uniqueIdAddIn = ''
      this.notFound = false
      this.loadingDoneAddIn = false
      this.loadingMore = false
      this.warehouseAddIn = []
    },
    toDetailPage(id){
      this.$router.push('/inventory/sparepart/detail/'+id)
    },
    submitEdit(){
      this.loadingButtonSave = true
      var self = this
      this.$http.post(process.env.INVENTORY_SPAREPART_DETAIL_EDIT,{
          componentWarehouseId:this.componentWarehouseIdEdit,
          sku:this.sku !== null ? this.sku.replace(this.spaceRegex, ' ') : this.sku,
          statusBefore:this.statusBefore,
          statusInput:this.statusEdit,
          warehouseBefore:this.warehouseBefore,
          warehouseInput:this.warehouseEdit.warehouseId,
          sparepartName:this.detailSparepart[0].componentName
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })

        }else if (response.data.status == 201) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          this.loadingButtonSave = false
        }else{
          swal("Success", response.data.message, "success", {
              button: "Close",
          });
          this.loadingButtonSave = false
          $("#modalEdit").modal('hide')
          this.getData()
        }
      })
      .catch(error => {
        self.loadingButtonSave = false
        alert('Error with API')
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    submitAddIn(btnChoose){
      if (btnChoose == 'done') {
        // $("#modalAdd").modal('hide')
        this.loadingDoneAddIn = true
      }else{
        this.loadingMore = true
      }
      var self = this
      this.$http.post(process.env.INVENTORY_SPAREPART_ADD_IN,{
          type:this.sourceAddIn,
          uniqueId: this.uniqueIdAddIn,
          qty: this.qtyAddIn,
          warehouseId: this.warehouseAddIn.warehouseId,
          condition: this.conditionAddIn.condition,
          sparepartName: this.dataGetAddIn[0].componentName
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })

        }else if (response.data.status == 201) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          this.loadingDoneAddIn = false
          this.loadingMore = false
        }else{
          swal("Success", response.data.message, "success", {
              button: "Close",
          });
          if (btnChoose == 'done') {
            $("#modalAdd").modal('hide')
            this.loadingDoneAddIn = false
          }else{
            this.loadingMore = false
          }
          this.resetAddIn()
          this.getData()
        }
      })
      .catch(error => {
        self.loadingDoneAddIn = false
        self.loadingMore = false
        alert('Error with API')
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    resetSearch(){
      this.searchWarehouse = {
        warehouseId:'All',
        warehouseName:'All'
      };
      this.searchStatus = 'All';
      this.currentPage = 1;
      this.searchData(1);
    },
    openModalEdit(data) {
      $("#modalEdit").modal('show')
      this.statusEdit = data.status
      this.statusBefore = data.status
      this.warehouseEdit = {
        warehouseId: data.warehouseId,
        warehouseName: data.warehouseName
      }
      this.warehouseBefore = data.warehouseId
      this.componentWarehouseIdEdit = data.componentWarehouseId
    },
    openModal(modalName) {
      $("#modal"+modalName).modal('show')
    },
    searchData(pagePost){
      this.$router.push({path:'/inventory/sparepart/detail/'+this.sku, query: {
              status:this.searchStatus,
              warehouseId:this.searchWarehouse.warehouseId,
              warehouseName:this.searchWarehouse.warehouseName,
              page:pagePost,
              itemPerPage:this.itemPerPage
          }
      })
    },
    toPage(e) {
      this.$router.push(e)
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin(){
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission(){
      this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
      for(var i=0; i < this.permission.length; i++){
        if( this.permission[i] == "1"){
          this.viewDashboard = true
        }
        if( this.permission[i] == "2.1"){
          this.viewOrder = true
        }
        if( this.permission[i] == "2.2"){
          this.editOrder = true
        }
        if( this.permission[i] == '3.1'){
          this.viewReturn = true
        }
        if( this.permission[i] == '3.2'){
          this.editReturn = true
        }
        if( this.permission[i] == '4.1'){
          this.viewProduct = true
        }
        if( this.permission[i] == '4.2'){
          this.editProduct = true
        }
        if( this.permission[i] == '5.1'){
          this.viewPairing = true
        }
        if( this.permission[i] == '5.2'){
          this.editPairing = true
        }
        if( this.permission[i] == '6'){
          this.viewReconcile = true
        }
        if( this.permission[i] == '7.1'){
          this.viewResolution = true
        }
        if( this.permission[i] == '7.2'){
          this.editResolution = true
        }
        if( this.permission[i] == '8.1'){
          this.viewLessor = true
        }
        if( this.permission[i] == '8.2'){
          this.editLessor = true
        }
        if( this.permission[i] == '9.1'){
          this.viewLessee = true
        }
        if( this.permission[i] == '9.2'){
          this.editLessee = true
        }
        if( this.permission[i] == '10'){
          this.viewEmployee = true
        }
      }
      if (this.viewProduct == false) {
        this.$router.push('/')
      }
    },
    sidebar(){
      $("#wrapper").toggleClass("toggled");
    },
    getData(){
      this.loadingTable = true
      this.searchWarehouse = {
        warehouseId : this.$route.query.warehouseId,
        warehouseName : this.$route.query.warehouseName
      }
      this.sku = this.$route.params.sku
      this.skuEdit = this.$route.params.sku
      this.searchStatus = this.$route.query.status
      this.currentPage = parseInt(this.$route.query.page)
      this.itemPerPage = parseInt(this.$route.query.itemPerPage)
      this.$http.post(process.env.SEARCH_INVENTORY_SPAREPART_DETAIL,{
        sku: this.$route.params.sku,
        status: this.$route.query.status,
        warehouseId: this.$route.query.warehouseId,
        page:this.currentPage,
        itemPerPage: this.itemPerPage
      },{
        headers: {'Asani-Token':localStorage.getItem('jwt')}
      })
      .then(response => {
        if (response.data.status == 400) {
              swal("Sorry", response.data.message, "error", {
                    button: "Ok",
                  })

            } else{
              this.detailSparepart = response.data.content.detailSparepart
              this.dataInvSparepart = response.data.content.data
              this.totalPage = response.data.content.totalPage
              this.currentPage = response.data.content.currentPage
              this.totalData = response.data.content.totalData
              this.warehouseOption = []
              this.warehouseOption.push({
                  warehouseId : 'All',
                  warehouseName : 'All'
              })
              this.warehouseOptionEdit = response.data.content.dataWarehouse
              this.warehouseOptionAddIn = []
              for (var i = 0; i < this.warehouseOptionEdit.length; i++) {
                this.warehouseOption.push({
                    warehouseId : this.warehouseOptionEdit[i].warehouseId,
                    warehouseName : this.warehouseOptionEdit[i].warehouseName
                })
                this.warehouseOptionAddIn.push({
                  warehouseId : response.data.content.dataWarehouse[i].warehouseId,
                  warehouseName : response.data.content.dataWarehouse[i].warehouseName
                })
              }
              this.loadingTable = false
              this.getWarehouseId(this.dataInvSparepart)
            }
      })
      .catch(error => {
        swal("Sorry", error.response.data.message, "error", {
          button: "Ok",
        }).then(v => {
          if(error.response.data.status == 401) {
            this.handleLogout()
          }
        })
      })
    },
    validateAddIn(btnChoose){
      if (this.qtyAddIn != 0) {
        if (this.sourceAddIn == 'Stock Opname' && this.warehouseAddIn.length != 0) {
          this.submitAddIn(btnChoose)
        }else{
          swal("Sorry", 'Warehouse must be choose', "error", {
            button: "Ok",
          })
        }
        if (this.sourceAddIn != 'Stock Opname') {
          this.submitAddIn(btnChoose)
        }
      }else{
        swal("Sorry", 'minimum qty 1', "error", {
          button: "Ok",
        })
      }
    },
  },
  created(){
    this.getData()
    this.admin = localStorage.getItem('admin_name')
    this.adminId = localStorage.getItem('admin_id')
    this.cekLogin()
    this.cekPermission()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .text-notif{
    color: red;
    font-size: 12px;
    margin-top: 10px;
    font-weight: bold;
  }
  table.add-in tr td{
    height: 42.2px;
  }
  .text-field{
    height: 42.2px;
  }
  .label-text-field{
    width: 100px;
  }
  .label-text-field-two{
    width: 121px;
  }
  .fixed_header{
      table-layout: fixed;
      border-collapse: collapse;
  }

  .fixed_header tbody{
    display:block;
    overflow:auto;
    height:200px;
    width:100%;
  }

  .fixed_header tbody.full-width tr td{
    width:1578px;
  }

  .fixed_header thead tr{
    display:block;
  }

  .fixed_header th, .fixed_header td {
    padding: 5px;
    text-align: left;
    width: 200px;
  }
  .text-label{
    width: 110px;
  }
  .text-field{
    height: 42.2px;
  }
  .label-text-field{
    width: 100px;
  }
  table {
    margin-bottom: 0px
  }
  .pagination{
    padding: 0px 0;
  }

  .pagination ul{
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  .pagination a{
    display: inline-block;
    padding: 1px 6px;
    color: #222;
  }

  .p8 a{
    background-color: #2797FB;
    /*margin: auto 5px;*/
    color: #fff;
    /*font-weight: bold;*/
    border: 1px solid #2797FB;
  }

  .p8 a:hover{
    text-decoration: none;
  }
  .p8 a.page:hover{
    text-decoration: none;
    color: #fff;
  }

  .p8 .is-active{
    background-color: #fff;
    color: #2797FB;
  }

  .total-data{
    font-size: 14px;
    color: #343A40;
  }
</style>



// WEBPACK FOOTER //
// src/components/Warehouse/InventorySparepartDetailPage.vue